import React, {useEffect, useReducer, useState} from 'react';
import clsx from "clsx";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import {Badge, Divider, Paper} from "@mui/material";
import ListItemText from "@mui/material/ListItemText";
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import AccountBalanceWalletTwoToneIcon from '@mui/icons-material/AccountBalanceWalletTwoTone';
import AllInboxTwoToneIcon from '@mui/icons-material/AllInboxTwoTone';
import BathtubTwoToneIcon from '@mui/icons-material/BathtubTwoTone';
import AirportShuttleTwoToneIcon from '@mui/icons-material/AirportShuttleTwoTone';
import PictureAsPdfTwoToneIcon from '@mui/icons-material/PictureAsPdfTwoTone';
import {initQuaranteneState, QUARANTENE_INITIAL_STATE, QuaranteneReducer} from "../../../../reducers/QuaranteneReducer";
import {getAllInfoProtocolli} from "../../../../services/QuaranteneServices";


const ProtocolliDrawer = ({selectMenuItem, stato,}) => {
	const classes = BaseStyle();
	const [open, setOpen] = useState(true);
	const [quarantenaState, quarantenaDispatch] = useReducer(QuaranteneReducer, QUARANTENE_INITIAL_STATE, initQuaranteneState);
	
	const handleDrawerOpenClose = () => {
		setOpen(!open);
	};
	
	useEffect(() => {
		getAllInfoProtocolli(quarantenaDispatch)
	}, [quarantenaDispatch]);
	
	
	return (
        <React.Fragment>
            <Paper
				className={clsx(classes.drawer, classes.roundBorder, open ? classes.openDrawer : classes.closedDrawer)}>
				<div style={{display: "flex", justifyContent: "center"}}>
					<Tooltip title={open ? "Comprimi menù" : "Espandi menù"}>
						<IconButton onClick={handleDrawerOpenClose} size="large">
							{!open ? <ChevronRightIcon/> : <ChevronLeftIcon/>}
						</IconButton>
					</Tooltip>
				</div>
				<List>
					<ListItem button className={classes.roundBorder} selected={stato === "Da protocollare"}
					          onClick={() => selectMenuItem("Da protocollare")}>
						<ListItemIcon>
							<Badge showZero badgeContent={quarantenaState.allInfoProtocolli?.["Da protocollare"]} color="primary"
							       max={9999}>
								<AllInboxTwoToneIcon/>
							</Badge>
						</ListItemIcon>
						<ListItemText primary={"Da protocollare"}/>
					</ListItem>
					<ListItem button className={classes.roundBorder} selected={stato === "Preso in carico"}
					          onClick={() => selectMenuItem("Preso in carico")}>
						<ListItemIcon>
							<Badge showZero badgeContent={quarantenaState.allInfoProtocolli?.["Preso in carico"]} color="primary"
							       max={9999}>
								<AirportShuttleTwoToneIcon/>
							</Badge>
						</ListItemIcon>
						<ListItemText primary={"Preso in carico"}/>
					</ListItem>
					<ListItem button className={classes.roundBorder} selected={stato === "Generato PDF"}
					          onClick={() => selectMenuItem("Generato PDF")}>
						<ListItemIcon>
							<Badge showZero badgeContent={quarantenaState.allInfoProtocolli?.["Generato PDF"]} color="primary"
							       max={9999}>
								<PictureAsPdfTwoToneIcon/>
							</Badge>
						</ListItemIcon>
						<ListItemText primary={"Generato PDF"}/>
					</ListItem>
					<ListItem button className={classes.roundBorder} selected={stato === "Protocollato"}
					          onClick={() => selectMenuItem("Protocollato")}>
						<ListItemIcon>
							<Badge showZero badgeContent={quarantenaState.allInfoProtocolli?.["Protocollato"]} color="primary"
							       max={9999}>
								<AccountBalanceWalletTwoToneIcon/>
							</Badge>
						</ListItemIcon>
						<ListItemText primary={"Protocollato"}/>
					</ListItem>
				</List>
				<Divider/>
				<List>
					<ListItem button className={classes.roundBorder} selected={stato === "In gestione"}
					          onClick={() => selectMenuItem("In gestione")}>
						<ListItemIcon>
							<Badge showZero badgeContent={quarantenaState.allInfoProtocolli?.["In gestione"]} color="primary"
							       max={9999}>
								<BathtubTwoToneIcon/>
							</Badge>
						</ListItemIcon>
						<ListItemText primary={"In gestione"}/>
					</ListItem>
				</List>
			</Paper>
        </React.Fragment>
    );
};

export default React.memo(ProtocolliDrawer)
